import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Grid } from '../../../Grid';
import { Panel } from '../../../Panel';
import { TrustpilotStars } from '../../../TrustpilotStars';
import { GoogleStars } from '../../../GoogleStars';

interface ReviewPanelsProps {
  googleUrl: string;
  googleRating: number;
}

// Styled Grid which is hidden on desktop

const StyledPanel = styled(Panel)`
  ${({ theme: { media } }) => css`
    a {
      margin: 0 auto;
    }
  `};
`;

export const ReviewPanels: FC<ReviewPanelsProps> = ({ googleUrl, googleRating }) => (
  <Grid desktopColumns="2">
    <StyledPanel backgroundColor="white" shadow>
      <TrustpilotStars rating={4.9} url="https://uk.trustpilot.com/review/www.kfh.co.uk" />
    </StyledPanel>
    <StyledPanel backgroundColor="white" shadow>
      <GoogleStars rating={googleRating} url={googleUrl} />
    </StyledPanel>
  </Grid>
);
